import Parse from 'html-react-parser';

function BMP20131(props) {
    let svgCode =
    `<svg width="42" height="88" viewBox="0 0 42 88" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M32 66H12V78H32V66ZM24 70H20V76H24V70Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22 58C19.7909 58 18 59.7909 18 62V66H14V62C14 57.5817 17.5817 54 22 54C26.4183 54 30 57.5817 30 62V66H26V62C26 59.7909 24.2091 58 22 58Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M32 22H12V34H32V22ZM24 26H20V32H24V26Z" fill="white" fill-opacity="0.2"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22 14C19.7909 14 18 15.7909 18 18V22H14V18C14 13.5817 17.5817 10 22 10C26.4183 10 30 13.5817 30 18V22H26V18C26 15.7909 24.2091 14 22 14Z" fill="white" fill-opacity="0.2"/>
    </svg>`

    props.svgReturn(59, svgCode, "bmp00131", 42, 88);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20131;